(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["obvs-working-guide"] && !Shopify.designMode) return;
  try {
    function initObvsQuestions() {
  document.querySelectorAll('[data-obvs-qa]').forEach(root => {
    if (root.dataset.qaReady) return;
    root.dataset.qaReady = 'true';
    const links = [...root.querySelectorAll('.obvs-questions__topics a')];
    const syncTopic = () => links.forEach(link => {
      if (link.hash === window.location.hash) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    syncTopic();
    window.addEventListener('hashchange', syncTopic);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) window.removeEventListener('hashchange', syncTopic);
    });
  });
}
initObvsQuestions();
document.addEventListener('shopify:section:load', initObvsQuestions);
  } catch(e) { console.error(e); }
})();

})();
